import React from "react";
import { Password } from "primereact/password";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo/logo.png";
import MusicLyric from "../../assets/icons/music-lyric.png";
import ResetPassword from "../../containers/ResetPassword.js";

export default function CreatePassword() {
    const { resetPassword, handleChange, handleResetPassword } = ResetPassword();
    return (
        <>
            <div className="px-8 shadow-2 flex justify-content-between align-items-center">
                <div className="logo">
                    <Link to="/">
                        <img src={Logo} alt="" width="200" className="mr-2"></img>
                    </Link>
                </div>
            </div>
            <div className="banner login-banner" style={{ height: "94vh" }}>
                <div className="grid  m-0 h-full align-items-center">
                    <div className="left-banner login lg:col-6 md:col-12 sm:col-12 relative  h-full vertical-center ">
                        <div className="relative">
                            <div className="spacer sm-hidden md-block"></div>
                            <h1 className="heading mb-3 z-2 font-semibold text-white">
                                <span className="text-white-border">Music </span>
                                <br />
                                is life
                                <br />
                                <span className="text-white-border"> Changing</span>
                            </h1>
                        </div>
                    </div>
                    <div className=" flex align-items-center lg:col-6 p-5 md:col-12 p-0 h-100 relative">
                        <img
                            src={MusicLyric}
                            alt=""
                            className="absolute opacity-20 w-5"
                            style={{ right: "2rem", top: "-2rem", zIndex: "-1" }}
                        />
                        <div className=" relative w-full">
                            <div className="shadow-1 p-3 py-6 border-round-lg w-9 relative z-3 bg-white">
                                <h3 className="text-2xl mb-3 font-bold">
                                    Create New <span className="text-main">Password</span>
                                </h3>
                                <form action="">
                                    <div className="mb-3">
                                        <label className="open-sans text-xs mb-2 ">New Password</label>
                                        <div className="border-set p-2 flex  border-round-lg align-items-center">
                                            <i className="pi pi-lock text-dark-gray font-bold"></i>
                                            <Password
                                                placeholder="New Password"
                                                className="border-none w-full ml-2"
                                                name="new_password"
                                                onChange={handleChange}
                                                value={resetPassword?.new_password}
                                                toggleMask
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="open-sans text-xs mb-2 ">Confirm New Password</label>
                                        <div className="border-set p-2 flex  border-round-lg align-items-center">
                                            <i className="pi pi-lock text-dark-gray font-bold"></i>
                                            <Password
                                                placeholder="Confirm password"
                                                className="border-none w-full ml-2"
                                                name="confirm_password"
                                                onChange={handleChange}
                                                value={resetPassword?.confirm_password}
                                                toggleMask
                                            />
                                        </div>
                                    </div>

                                    <button
                                        className="bg-dark w-full p-3 border-none text-white font-semibold border-round-lg open-sans"
                                        onClick={(e) => handleResetPassword(e)}
                                    >
                                        Continue
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
